import React, { useEffect } from 'react';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { CommonModalWrapper } from './style';

const CommonModal = ({ showModal = false, setShowModal, modalData = {} }) => {
  useEffect(() => {
    document.body.style.overflow = showModal ? 'hidden' : 'auto';

    return () => {
      // Cleanup: 모달이 사라질 때 overflow 복원
      document.body.style.overflow = 'auto';
    };
  }, [showModal]);

  const {
    contents,
    closeBtnShow = false,
    cancelBtnName = '',
    onClickCancelBtn = () => {
      setShowModal(false);
    },
    confirmBtnName = '',
    confirmBtnWidth = '',
    onClickConfirmBtn = () => {},
    confirmBtnDisabled = false,
    onClickCloseBtn = () => {
      setShowModal(false);
    },
    isVerticalBtn = false,
    textAlign = 'center',
    fontWeight = 500,
  } = modalData || {};

  const isHTML = str => /<[^>]+>/.test(str);

  return (
    showModal && (
      <CommonModalWrapper
        textAlign={textAlign}
        fontWeight={fontWeight}
        isVerticalBtn={isVerticalBtn}
        width={confirmBtnWidth}
      >
        <div className="container">
          {(!confirmBtnName && !cancelBtnName) || closeBtnShow ? (
            <button
              type="button"
              className="btnClose"
              onClick={onClickCloseBtn}
            >
              <FeatherIcon icon="x" size={24} strokeWidth={2.2} />
            </button>
          ) : null}

          {contents &&
            (!isHTML(contents) ? (
              <div className="content">{contents}</div>
            ) : (
              <div
                className="content"
                dangerouslySetInnerHTML={{ __html: contents }}
              />
            ))}
          {confirmBtnName && (
            <div className="btnGroupWrapper">
              {cancelBtnName && (
                <button
                  type="button"
                  className="btnCancel"
                  onClick={onClickCancelBtn}
                >
                  {cancelBtnName || '취소'}
                </button>
              )}
              <button
                type="button"
                className="btnConfirm"
                onClick={onClickConfirmBtn}
                disabled={confirmBtnDisabled}
              >
                {confirmBtnName || '확인'}
              </button>
            </div>
          )}
        </div>
      </CommonModalWrapper>
    )
  );
};

export default CommonModal;
